import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'

import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'
import { SharedModule } from '@tv3/shared/shared.module'

import { SecurityDepositOverlayComponent } from './security-deposit-overlay.component'

@NgModule({
  declarations: [SecurityDepositOverlayComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatFormFieldModule,
    Tv3PlatformModule,
    SharedModule,
  ],
  exports: [SecurityDepositOverlayComponent],
})
export class SecurityDepositOverlayModule {}
